import './LanguageInfo.scss';

const LanguageInfo = function(props) {
	if (!props.language) {
		return (
			<p className="language-info">No language selected. Please select language in the <a href="#" onClick={props.toggleSettingsCallback}>settings</a> panel.</p>
		);
	}

	return (
		<p className="language-info">Current language is: <b>{props.language.name}</b> <span className="hint">You can change language in the <a href="#" onClick={props.toggleSettingsCallback}>settings</a></span></p>
	)
}

export default LanguageInfo;